import React, { useEffect, useState } from "react";
import DashboardCalendar from "./DashboardCalendar.js";
import StudentListData from "./StudentListData.js";

import StudentExamResult from "./StudentExamResult.js";
import StudentUpcomingWebinar from "./StudentUpcomingWebinar";
import moment from "moment/moment";
import Ticker from "./Ticker";
import axiosInstance from "../../axios";
import { Loading } from "../Other/Loading";

const StudentDashboard = () => {
  const [getJustAddedCourse, setGetJustAddedCourse] = useState();
  const [fetchStatus, setFetchStatus] = useState(true);
  const [dataIndex, setDataIndex] = useState(5);
  const [progressIndex, setProgressIndex] = useState(5);

  useEffect(() => {
    axiosInstance
      .get("/course/purchased")
      .then((res) => {
        setGetJustAddedCourse(res?.data?.data.data);
        setFetchStatus(false);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const checkCompletedSections = (progress) => {
    if (
      "totalSection" in progress &&
      "finishedSection" in progress &&
      progress.totalSection > 0
    ) {
      return (progress.finishedSection / progress.totalSection) * 100;
    }

    return 0;
  };

  const coursePercentageCalutation = (value) => {
    const totalDuration = value.totalDuration;
    const totalDurationCompleted = value.totalDurationCompleted;
    const percenatge = (totalDurationCompleted / totalDuration) * 100;
    return totalDuration === 0
      ? 0
      : isNaN(percenatge)
      ? checkCompletedSections(value)
      : percenatge;
  };

  return (
    <>
      <div>
        <div className="dashboard-container-new studentDashboard-Data">
          <p>Dashboard</p>

          <Ticker />
        </div>
        <div className="dashboard-main">
          <div className="flex-80">
            <StudentListData />
            <div className="dashboard-main">
              <div className="flex-chart-60">
                <div className="margin-top-new-01">
                  <div className="box-shadow-new-01">
                    <div>
                      <p className="paragraph-css">Your Progress</p>
                    </div>
                    {fetchStatus && (
                      <div className="admindata-loading">
                        <Loading />
                      </div>
                    )}
                    <table
                      id="customers"
                      className="studentfetchData studentProgressData"
                    >
                      <thead>
                        <tr>
                          <th className="fs-10">Course Name</th>
                          <th className="fs-10">Date</th>
                        </tr>
                      </thead>

                      <tbody>
                        {getJustAddedCourse &&
                          getJustAddedCourse.length > 0 &&
                          getJustAddedCourse
                            .slice(0, progressIndex)
                            .map((ele, index) => (
                              <tr key={index}>
                                <td>{ele.CourseName}</td>
                                <td>
                                  {moment(ele.CreatedOn).format("DD/MM/YYYY")}
                                </td>
                                <td>
                                  <div className="progress-bar-status">
                                    <label>
                                      {`${coursePercentageCalutation(
                                        ele?.progress
                                      ).toFixed(0)}%`}
                                    </label>
                                  </div>
                                  <progress
                                    className={
                                      `${coursePercentageCalutation(
                                        ele.progress
                                      ).toFixed(0)}` > 50 &&
                                      `${coursePercentageCalutation(
                                        ele.progress
                                      ).toFixed(0)}` < 75
                                        ? "progressBar50"
                                        : `${coursePercentageCalutation(
                                            ele.progress
                                          ).toFixed(0)}` < 50
                                        ? "progressBar25"
                                        : `${coursePercentageCalutation(
                                            ele.progress
                                          ).toFixed(0)}` > 75 &&
                                          `${coursePercentageCalutation(
                                            ele.progress
                                          ).toFixed(0)}` < 85
                                        ? "progressBar80"
                                        : "progressBarColor"
                                    }
                                    value={`${coursePercentageCalutation(
                                      ele.progress
                                    )}`}
                                    max="100"
                                  ></progress>
                                </td>
                              </tr>
                            ))}
                      </tbody>
                    </table>
                    {getJustAddedCourse && getJustAddedCourse.length > 5 && (
                      <div
                        className="studentViewAllRecords"
                        onClick={() =>
                          setProgressIndex(
                            getJustAddedCourse && progressIndex === 5
                              ? getJustAddedCourse.length
                              : 5
                          )
                        }
                      >
                        {progressIndex === 5 ? "View All" : "View Less"}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <StudentUpcomingWebinar />
            </div>
            <StudentExamResult />
          </div>
          <div className="flex-20">
            <div className="box-shadow-new-01">
              <p className="paragraph-css">Just added Courses</p>
              {fetchStatus && (
                <div className="admindata-loading">
                  <Loading />
                </div>
              )}
              {getJustAddedCourse &&
                getJustAddedCourse.length > 0 &&
                getJustAddedCourse.slice(0, dataIndex).map((ele, index) => (
                  <div className="avator-padding-bottom" key={index}>
                    <div className="new-profile-flex new-profile-flex-70">
                      <div>
                        <p className="profile-data justAddedCourse">
                          {`${ele.CourseName.substring(0, 25)}...`}
                        </p>
                        <p className="profile-data-1">{ele.instructorName}</p>
                      </div>
                    </div>
                    <div className="new-profile-flex-15">
                      <p className="data-paragraph-css">15hr</p>
                      <p className="data-paragraph-css">{ele.EnrollmentFee}</p>
                    </div>
                  </div>
                ))}
              {getJustAddedCourse && getJustAddedCourse.length > 5 && (
                <div
                  className="studentViewAllRecords"
                  onClick={() =>
                    setDataIndex(
                      getJustAddedCourse && dataIndex === 5
                        ? getJustAddedCourse.length
                        : 5
                    )
                  }
                >
                  {dataIndex === 5 ? "View All" : "View Less"}
                </div>
              )}
            </div>

            <div className="box-shadow-new-01 eventCalendarStatus">
              <p className="paragraph-css pb-15">Event Calendar</p>
              <DashboardCalendar />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default StudentDashboard;
